import React, { Component } from 'react';

class AdTop extends Component {
    componentDidMount() {
        try {
            // window.googletag.cmd.push(function () {
            //     window.googletag.display('div-gpt-ad-1410518459199-0');
            // });
            if (window.googletag && window.googletag.apiReady) {
                window.googletag.cmd.push(function () {
                    window.googletag.display('div-gpt-ad-1410518459199-0');
                });
                window.googletag.pubads().refresh([window.gptAdSlots[0]]);
            }
        } catch (e) {
        }
    }

    render() {
        return <div id='div-gpt-ad-1410518459199-0' />
    }
}

export default AdTop;


// WEBPACK FOOTER //
// ./src/components/AdTop.js